export default __webpack_public_path__ + "static/media/Close_Eye.4ccdf2a4.svg";